import React, {Component} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames';
import querystring from 'query-string'
import autobind from 'autobind-decorator';

import ItemAllCheckbox from '../../common/EntryItemAllCheckbox';
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import { parseListParams } from '../../common/EntryListHelper';
import { selectAllItems, deselectAllItems, updateSelectedItems, receiveItems  } from '../../../actions/contents/notice'
import WindowEventHelper from "../../../lib/WindowEventHelper";
import TSelectFilter from "../../common/TSelectFilter";
import * as StatusTypes from '../../../constants/contents/EntryStatusTypes';
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    items: state.notice.item.items,
    searchKeyword: state.notice.condition.searchKeyword,
    searchType: state.notice.condition.searchType,
}), dispatch => ({
    handleSelectAllItems: () => {
        dispatch(selectAllItems())
    },
    handleDeselectAllItems: () => {
        dispatch(deselectAllItems())
    },
    handleUpdateSelectedItems: (values) => {
        dispatch(updateSelectedItems(values))
    },
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    dispatch
}))
class NoticeListHeader extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            optionOpen: false,
            searchOpen: false,
            processing: false,
            deleting: false,
            searching: false,
            searchKeyword : '',
            searchType: 'title',
            searchTypeOptions : [{ label : '제목', value: 'title'},
                { label : '내용', value: 'content'},
                { label : '태그', value: 'tag'}]
        };

        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleToggleOption = this.handleToggleOption.bind(this);
        this.handleHideOption = this.handleHideOption.bind(this);
        this.handleOpenSearch = this.handleOpenSearch.bind(this);
        this.handleCloseSearch = this.handleCloseSearch.bind(this);
        this.handleCloseSearchWithKey = this.handleCloseSearchWithKey.bind(this);
        this.updateItems = this.updateItems.bind(this);
        this.handleVisible = this.handleVisible.bind(this);
        this.handleHidden = this.handleHidden.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.fetchNotices = this.fetchNotices.bind(this);
    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleHideOption)
		WindowEventHelper.add("keydown", this.handleCloseSearchWithKey)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleHideOption)
		WindowEventHelper.remove("keydown", this.handleCloseSearchWithKey)
    }

    componentWillReceiveProps(nextProps) {
        const { searchKeyword, searchType } = this.state;
        const nextSearchKeyword = nextProps.searchKeyword;
        const nextSearchType = nextProps.searchType;
        if(nextSearchKeyword === '' || (searchKeyword === nextSearchKeyword && searchType === nextSearchType)){
            this.setState({
                searching: false,
            });
        }
    }

    handleSelectAll(e) {
        const { handleSelectAllItems, handleDeselectAllItems } = this.props;
        if (e.target.checked) {
            handleSelectAllItems()
        } else {
            handleDeselectAllItems()
        }
    }

    handleToggleOption(e) {
        const { optionOpen } = this.state;

        this.setState({
            optionOpen: !optionOpen
        })
    }

    handleHideOption(e) {
        const { btnOptionOpen } = this.refs;
        if (e.target !== btnOptionOpen
            && e.target.parentNode
            && e.target.parentNode !== btnOptionOpen
            && e.target.parentNode.className !== "list_opt"
            && e.target.parentNode.parentNode
            && e.target.parentNode.parentNode.className !== "list_opt") {
            this.setState({
                optionOpen: false
            })
        }
    }

    handleOpenSearch(e) {
        const { searchText } = this.refs;
        searchText.value='';
        this.setState({
            searchOpen: true,
            searchKeyword:'',
            searchType: 'title',
        });
        setTimeout(() => { searchText.focus() }, 100)

    }

    handleCloseSearch(e) {
        this.setState({
            searchOpen: false
        })
    }

    handleCloseSearchWithKey(e) {

        if (this.state.searchOpen) {
            if(e.keyCode === 27) {
                this.handleCloseSearch()
            }else if(e.keyCode === 13) {
                this.handleSearch();
                this.handleCloseSearch();
            }
        }
    }

    handleSearch() {

        const { searchKeyword, searchType}  = this.state;

        let history = this.props.history;
        let location = this.props.location;

        if (searchKeyword.length > 0) {

            let listParams = parseListParams(location.search);
            if(listParams.searchKeyword !== searchKeyword || listParams.searchType !== searchType){
                history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword, searchType : searchType}));
                this.setState({
                    searching: true,
                });
            }
        }
        this.handleCloseSearch();
    }

    updateItems(changes) {
        const { items, handleUpdateSelectedItems, dispatch } = this.props;
        let ids = items.filter(item => item.selected).map(item => item.id);
        this.setState({
            processing : true
        });
        handleUpdateSelectedItems({ processing : true});
        fetch(addPrefix("/manage/notices/visibility.json"), {
            method: "put",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify(
                Object.assign({}, { ids: ids.join(",") }, changes)
            )
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                changes.processing = false;
                handleUpdateSelectedItems(changes);
                this.setState({
                    optionOpen: false,
                    processing : false
                })
            })
            .catch(r => {
                handleUpdateSelectedItems({ processing : false});
                this.setState({
                    optionOpen: false,
                    processing : false
                });
                console.error(r)
            })
    }

    handleVisible(e) {
        this.updateItems({visibility: StatusTypes.PUBLIC});
    }

    handleHidden(e) {
        this.updateItems({visibility: StatusTypes.PRIVATE});
    }

    handleDelete(e) {

        if(confirm('선택한 공지를 삭제하시겠습니까?')){

            const { items, handleUpdateSelectedItems, dispatch } = this.props;
            let ids = items.filter(item => item.selected).map(item => item.id);
            handleUpdateSelectedItems({ deleting : true});
            this.setState({
                deleting:true
            });

            fetch(addPrefix("/manage/notices.json"), {
                method: "delete",
                credentials: "include",
                headers: {'Content-Type':'application/x-www-form-urlencoded'},
                body: querystring.stringify({
                    ids: ids.join(",")
                })
            })
                .then(jsonResponseHandler(dispatch))
                .then(data => {
                    this.fetchNotices();
                })
                .catch(r => {
                    this.setState({
                        optionOpen: false,
                        deleting:false
                    });
                    handleUpdateSelectedItems({ deleting : false});
                    console.error(r);
                })
        }
    }

    fetchNotices() {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/notices.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount);
                this.setState({
                    optionOpen: false,
                    deleting:false
                })
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    optionOpen: false,
                    deleting:false
                })
            })
    }

    searchUpdated (event) {
        const keyword = event.target.value;
        this.setState({searchKeyword: keyword})
    }

    @autobind
    selectSearchType(item, idx) {

        this.setState({
            searchType: item.value
        })
    }

    render() {

        const { optionOpen, searchOpen, searchKeyword, processing, deleting, searching, searchTypeOptions, searchType } = this.state;
        const { items } = this.props;

        let selectedCount = items.filter(item => item.selected).length;

        let optionAvailable = selectedCount > 0;
        let searchable = searchKeyword.length > 0;

        if(searching) {
            return (<div className="wrap_search loading_search">
                <TSelectFilter className={"filter_search"} items={searchTypeOptions} disabled={true}
                               selected={searchType}
                               onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
                <em className="txt_keyword">{searchKeyword}</em>
                <span className="txt_change">
                        검색중
                        <span className="ico_blog ico_change"/>
                    </span>
            </div>);
        }

        return (
            <div className={classnames({
            "wrap_search": true,
            "on": searchOpen
            })}>
                <ItemAllCheckbox items={items} handleSelectAll={this.handleSelectAll}/>
                <div className="search_blog">
                    <TSelectFilter className={"filter_search"} items={searchTypeOptions}
                                   selected={searchType}
                                   onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
                    <input type="text" className="tf_search" title="검색어 입력" placeholder="공지 관리에서 검색합니다." ref="searchText" onChange={(e) => this.searchUpdated(e)} />
                    <div className="info_search">
                        <button type="button" className="btn_search" onClick={this.handleOpenSearch}>
                            검색
                            <span className="ico_blog ico_search"> 열기</span>
                        </button>
                        <button type="button" className="btn_search btn_query" disabled={!searchable} onClick={this.handleSearch}>
                            <span className="ico_blog ico_search">검색 하기</span>
                        </button>
                        <button type="reset" className="btn_del" onClick={this.handleCloseSearch}>닫기</button>
                    </div>
                </div>
                <div className={classnames({
                    "opt_blog": true,
                    "opt_open": optionOpen,
                    "change_on" : (processing || deleting)
                })}>
                    <button ref="btnOptionOpen" type="button" className="btn_opt" disabled={!optionAvailable} onClick={this.handleToggleOption}>
                        변경
                        <span className="ico_blog ico_open" />
                    </button>
                    <span className="txt_change">
                        { processing && "변경중"}
                        { deleting && "삭제중"}
                        <span className="ico_blog ico_change"/>
                    </span>
                    <div className="layer_opt layer_double">
                        <strong className="tit_opt">상태 변경</strong>
                        <ul className="list_opt">
                            <li>
                                <label className="lab_btn">
                                    공개
                                    <input type="button" className="btn_g" value="공개" onClick={this.handleVisible}/>
                                </label>
                            </li>
                            <li>
                                <label className="lab_btn">
                                    비공개
                                    <input type="button" className="btn_g" value="비공개" onClick={this.handleHidden}/>
                                </label>
                            </li>
                            <li>
                                <label className="lab_btn">
                                    삭제
                                    <input type="button" className="btn_g" value="삭제" onClick={this.handleDelete}/>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>);

        }
}

export default NoticeListHeader;
